import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';

import { DemoModeService } from './demo-mode.service';

@Component({
  selector: 'app-demo-badge',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (showBadge()) {
      <div class="demo-badge" role="status">
        <span class="demo-badge__dot" aria-hidden="true"></span>
        <span class="demo-badge__label">Demo data</span>
        <button type="button" class="demo-badge__exit" (click)="exit()">
          {{ demoMode.exitLabel() }}
        </button>
      </div>
    }
  `,
  styles: [
    `
      .demo-badge {
        position: fixed;
        right: max(0.75rem, env(safe-area-inset-right));
        bottom: calc(env(safe-area-inset-bottom) + 4.75rem);
        z-index: 1000;
        display: flex;
        align-items: center;
        gap: 0.5rem;
        padding: 0.35rem 0.5rem 0.35rem 0.65rem;
        border-radius: 999px;
        background: #1f2933;
        color: #fff;
        box-shadow: 0 4px 14px rgb(0 0 0 / 25%);
        font-size: 0.75rem;
        line-height: 1;
        pointer-events: auto;
      }

      .demo-badge__dot {
        width: 0.5rem;
        height: 0.5rem;
        border-radius: 50%;
        background: #f0b429;
      }

      .demo-badge__label {
        font-weight: 600;
        letter-spacing: 0.04em;
        text-transform: uppercase;
      }

      .demo-badge__exit {
        padding: 0.25rem 0.6rem;
        border: 0;
        border-radius: 999px;
        background: rgb(255 255 255 / 15%);
        color: inherit;
        font: inherit;
        cursor: pointer;
      }

      .demo-badge__exit:hover {
        background: rgb(255 255 255 / 25%);
      }
    `,
  ],
})
export class DemoBadgeComponent {
  protected readonly demoMode = inject(DemoModeService);

  /**
   * Hidden on the hosted demo: the whole site is the demo, so a floating pill
   * only covers real UI (it was landing on top of the planner's Next button).
   * Kept for local dev, where the app can be in either mode and knowing which
   * one you are looking at matters. Reloading restarts a hosted demo.
   */
  protected readonly showBadge = computed(() => this.demoMode.active() && !this.demoMode.autoStart);

  protected exit(): void {
    void this.demoMode.exit();
  }
}
